export const GameCodeConsts = {
    Qtech:"qtech",
    Gap:"gap",
    DC:"dc",
    AWC:"awc",
    SAP:"sap"
}